import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {keyboardHandler} from '@containers/hooks'

const TwLinkMenu = tw.div`
  shadow-md
  py-2
  px-4
  flex
  gap-4
  items-center
  bg-background-tooltip-informer
  rounded-4
`

const TwInputWrapper = tw.div`
  relative
  isolate
  flex
  items-center
  w-fit
  h-16
  after:content-[""]
  after:absolute
  after:top-0
  after:bottom-0
  after:left-0
  after:right-0
  after:rounded-4
  after:opacity-20
  after:bg-invert
  after:-z-10
`

const TwInput = tw.input`
  inline-block
  relative
  h-16
  w-36
  px-4
  py-0
  m-0
  
  shadow-none
  border-none
  outline-none
  focus:border-none
  focus:outline-none
  focus:bg-transparent
  focus:shadow-none
  
  bg-transparent
  text-invert
  text-center
  text-xs-regular
  
  no-spinner
`

interface LinkMenuNewProps {
  gap: number
  className?: string
}

export const AutoPlanningMenu = observer<LinkMenuNewProps>(
  ({gap: originalGap, className}) => {
    const [, store] = useTimelineNewStore()

    const ref = useRef<HTMLElement>(null)
    useEffect(() => {
      const fn = (e: WheelEvent) => e.stopPropagation()
      ref.current?.addEventListener('wheel', fn, {passive: false})
      return () => ref.current?.removeEventListener('wheel', fn, {})
    }, [ref])

    const [gap, setGap] = useState(originalGap.toString())

    const changeGap = (e: React.ChangeEvent<HTMLInputElement>) => {
      const original = e.target.value
      const parsed = parseInt(original)

      if (!Number.isFinite(parsed)) {
        setGap(original)
        return
      }

      const clamped = Math.max(-365, Math.min(365, parsed))
      setGap(clamped.toString())
    }

    const saveLinkData = () => {
      const parsedGap = parseInt(gap)
      const validGap = Number.isFinite(parsedGap) ? parsedGap : 0
      store.editSelectedLinkData({gap: validGap})
      store.cancelLinkEdit()
      return true
    }

    return (
      <TwLinkMenu ref={ref} className={className} data-tippy-root>
        <Icon icon="IconClock" className="text-icon-invert" />
        <span className="text-xs-regular text-icon-invert">
          {Lang.msg.timeline.lag}:
        </span>
        <TwInputWrapper>
          <TwInput
            type="number"
            min={-365}
            max={365}
            step={1}
            value={gap}
            onChange={changeGap}
            autoFocus
            onKeyDown={e => {
              if (e.key === '-' && gap === '0') {
                setGap('-')
              } else if (e.key === '+' && gap === '0') {
                setGap('+')
              }
            }}
            onKeyUp={keyboardHandler({enter: saveLinkData})}
          />
        </TwInputWrapper>
        <Icon
          icon="IconCheck"
          color="action-default"
          className="cursor-pointer"
          onClick={saveLinkData}
        />
      </TwLinkMenu>
    )
  }
)
